import { BookItem, DigitalServiceItem } from "../types";

export type CollectionSelection = {
  prefix: string;
  linkName: string;
  href: string | null;
};

export const selectCollection = (
  item: BookItem | DigitalServiceItem,
): CollectionSelection | null => {
  const { literaryWork } = item.itemDetails;

  if (
    item.itemType === "book" &&
    item.itemDetails.numberInSeries &&
    item.itemDetails.seriesName &&
    item.itemDetails.bookSeries?.slug
  ) {
    return {
      prefix: `Bok ${item.itemDetails.numberInSeries} i `,
      linkName: item.itemDetails.seriesName,
      href: item.itemDetails.bookSeries.slug
        ? `/serie/${item.itemDetails.bookSeries.slug}`
        : null,
    };
  }

  if (literaryWork) {
    return {
      prefix: "En del av ",
      linkName: literaryWork.name,
      href: literaryWork.slug ? `/verk/${literaryWork.slug}` : null,
    };
  }

  return null;
};
